<div class="settings-container" [style.--header-height]="layoutService.headerHeight$() + 'px'">
  <nav>
    @for (option of settingsOptions; track option) {
      <pdq-option
        variant="navigation"
        [routerLinkActive]="'active'"
        [routerLink]="option.url"
        [optionId]="option.name"
        [isSelected]="route.url.includes(option.url)">
        <span class="opt-name caption-xsmall-caps">{{ option.name }}</span>
      </pdq-option>
    }
  </nav>
</div>
